import React from 'react';
const tomos = [{
  num: '01',
  title: 'El Negocio que Sangra',
  subtitle: 'El diagnóstico que ninguna lashista quiere ver pero todas necesitan',
  desc: 'Cuánto perdés realmente por cada cancelación. La auditoría de pérdidas reales. La proyección a 6 meses. La identidad que te frena. La psicología de la cancelación y el manifiesto de la lashista dueña de su negocio.'
}, {
  num: '02',
  title: 'El Filtro de Acero',
  subtitle: 'Cómo evitar que el problema entre antes de que exista',
  desc: 'Instagram como filtro de clientas. El primer mensaje como detector de riesgo. La seña como herramienta de compromiso. Scripts para cobrar sin inseguridad. El formulario pre-turno y el sistema de semáforo verde-amarillo-rojo para evaluar cada clienta nueva.'
}, {
  num: '03',
  title: 'Políticas de Tolerancia Cero',
  subtitle: 'Las reglas claras que hacen que tu tiempo valga',
  desc: 'Política de llegada tarde. Costo oculto de la tolerancia. Cómo comunicar políticas antes del problema. Sistema de consecuencias. Banco de 30 mensajes de WhatsApp. Sistema de recordatorios 72-24-2. Blacklist estratégico y despedida profesional.'
}, {
  num: '04',
  title: 'La Agenda Invulnerable',
  subtitle: 'El sistema que llena huecos y construye una agenda predecible',
  desc: 'Bloques de oro, plata y bronce. Arquitectura semanal diseñada. Lista de espera activa. Sistema de rellenado de turno en 15 minutos. Club VIP. Plan de 90 días de implementación y el cierre del sistema completo.'
}];
const checklist = ['Sistema listo para implementar desde el día 1', 'Checklists y plantillas para usar de inmediato', 'Scripts y mensajes listos para copiar y pegar', 'Casos reales del contexto de lashistas argentinas', 'Cierre con resumen accionable por tomo', '100% adaptado a la realidad argentina 2025'];
const bonos = [{
  num: '01',
  title: 'Kit Express Anti-Cancelación en 10 Minutos',
  desc: 'Activá un mini sistema anti-cancelación hoy mismo aunque nunca hayas puesto reglas antes. Tu monto de seña definido, tu política lista, tus mensajes guardados en WhatsApp y tu primer turno blindado. Todo en 10 minutos.',
  value: '$12.000'
}, {
  num: '02',
  title: '25 Respuestas Rápidas para Clientas que Quieren Cambiar, Mover o Cancelar',
  desc: 'Respondé con firmeza y elegancia cualquier intento de cancelación sin quedarte en blanco ni regalar tu tiempo. 25 mensajes listos para copiar y pegar organizados por escenario, tono y nivel de firmeza.',
  value: '$15.000'
}, {
  num: '03',
  title: 'Checklist de Clienta de Riesgo',
  desc: 'Detectá en minutos si una clienta tiene perfil de canceladora antes de darle un lugar en tu agenda. Sistema de semáforo verde-amarillo-rojo con 21 señales de alerta y protocolo de decisión para cada color.',
  value: '$12.000'
}, {
  num: '04',
  title: 'Plan de Rescate de Turno Caído',
  desc: 'Convertí un turno cancelado en una nueva oportunidad de ingreso en menos de 15 minutos. Protocolo de 6 pasos, mensajes exactos de rescate y sistema de seguimiento para mejorar mes a mes.',
  value: '$12.000'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-white border-y border-[#E8D5C4]" data-id="element-160">
      <div className="max-w-6xl mx-auto px-4" data-id="element-161">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-162">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FAF6F0] text-[#B8956A] font-bold text-xs tracking-[0.2em] uppercase mb-6 border border-[#E8D5C4]" data-id="element-163">
            🏆 Kit Lashista Tu Agenda Profesional™
          </div>
          <h2 className="text-4xl md:text-6xl text-[#2D1A22] mb-4 leading-tight" data-id="element-164">
            4 Tomos <span className="italic" data-id="element-165">+</span> 4 Bonos
          </h2>
          <p className="text-lg md:text-xl text-[#5A4A4F] italic" data-id="element-166">
            El Sistema N°1 para Lashistas Argentinas
          </p>
          <p className="text-sm text-[#B8956A] mt-3 tracking-wider uppercase" data-id="element-167">
            Más de 320 páginas — Todo listo para implementar
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid md:grid-cols-2 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-168">
          {tomos.map((t, i) => <div key={i} className="bg-[#FAF6F0] border border-[#E8D5C4] rounded-2xl p-6 md:p-10 hover:border-[#B8956A] transition-all group relative overflow-hidden" data-id="element-169">
              <div className="absolute top-0 right-0 w-32 h-32 rounded-bl-full bg-gradient-to-br from-transparent to-[#E8D5C4]/30 -mr-10 -mt-10" data-id="element-170" />
              <div className="relative z-10" data-id="element-171">
                <div className="flex items-baseline gap-3 mb-4" data-id="element-172">
                  <span className="text-5xl md:text-6xl text-[#B8956A] font-light italic" style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-173">
                    {t.num}
                  </span>
                  <span className="text-xs tracking-[0.25em] text-[#5A2A3D] font-bold uppercase" data-id="element-174">
                    Tomo
                  </span>
                </div>
                <h3 className="text-2xl md:text-3xl text-[#2D1A22] mb-2 leading-tight" data-id="element-175">
                  {t.title}
                </h3>
                <p className="text-sm md:text-base text-[#5A2A3D] italic mb-4" data-id="element-176">
                  {t.subtitle}
                </p>
                <p className="text-[#5A4A4F] leading-relaxed text-sm md:text-base" data-id="element-177">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-[#FAF6F0] border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-6 md:p-10 mb-20 md:mb-28" data-id="element-178">
          <h3 className="text-2xl md:text-3xl text-[#2D1A22] mb-6 md:mb-8 text-center" data-id="element-179">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-180">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-181">
                <span className="text-[#B8956A] mt-0.5 shrink-0" data-id="element-182">✓</span>
                <span className="text-[#5A4A4F] font-medium text-sm md:text-base" data-id="element-183">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-184">
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-185">
            🎁 Siempre incluidos
          </div>
          <h2 className="text-4xl md:text-6xl text-[#2D1A22] mb-4 leading-tight" data-id="element-186">
            4 Bonos <span className="italic" data-id="element-187">de Acción Inmediata</span>
          </h2>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-188">
          {bonos.map((b, i) => <div key={i} className="bg-white border border-[#E8D5C4] rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col shadow-sm" data-id="element-189">
              <div className="absolute top-0 right-0 w-28 h-28 bg-[#B8956A]/10 rounded-bl-full -mr-8 -mt-8" data-id="element-190" />
              <div className="text-[#B8956A] font-bold text-xs tracking-[0.25em] uppercase mb-3 relative z-10" data-id="element-191">
                Bono {b.num}
              </div>
              <h3 className="text-xl md:text-2xl text-[#2D1A22] mb-3 leading-tight" data-id="element-192">
                {b.title}
              </h3>
              <p className="text-[#5A4A4F] text-sm md:text-base mb-6 flex-1 leading-relaxed" data-id="element-193">
                {b.desc}
              </p>
              <div className="pt-5 border-t border-[#E8D5C4] flex items-center justify-between" data-id="element-194">
                <span className="text-[#B8956A]/70 line-through font-mono text-sm" data-id="element-195">
                  {b.value}
                </span>
                <span className="bg-[#5A2A3D] text-white font-bold px-4 py-1.5 rounded-full text-xs uppercase tracking-wider" data-id="element-196">
                  Gratis
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-[#FAF6F0] border border-[#B8956A]/40 rounded-2xl p-6 md:p-8" data-id="element-197">
          <div className="text-[#B8956A] font-bold mb-2 uppercase tracking-[0.2em] text-xs" data-id="element-198">
            Valor total bonos
          </div>
          <div className="text-2xl md:text-3xl" data-id="element-199">
            <span className="line-through text-[#5A4A4F]/60 mr-3" data-id="element-200">$51.000</span>
            <span className="text-[#5A2A3D] italic" data-id="element-201">→ Gratis con tu Kit</span>
          </div>
        </div>
      </div>
    </section>;
}